/**************************************************
 * Nombre:       Formacion_PorQue
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_color.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Formacion_PorQue = () => {
    const {sCell} = useResponsive()
    const {props} = useFormulario({valoresDefecto: {}})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      spacing={8}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        spacing={0}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Typography sx={{
                                fontSize: sCell ? 32 : 40,
                                fontFamily: NEGRITA,
                                lineHeight: 1.1,
                                fontWeight: 600,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                Por que Estudiar TECNICO LABORAL POR COMPETENCIAS ASISTENTE ADMINISTRATIVO
                            </Typography>
                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 6}}
                        sx={{mt: sCell ?  0  : 10}}
                    >

                        <img src={logo} width={sCell ? '60%' : '80%'} height={'auto'}/>
                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_PorQue

const items = [1, 2, 3, 4, 5, 6]